const adminLinkRouter = [
  {
    path: '/admin/link',
    name: 'AdminLinkIndex',
    component: () => import('@/views/admin/link/index')
  },
  {
    path: '/admin/link/create',
    name: 'AdminLinkCreate',
    component: () => import('@/views/admin/link/create')
  },
  {
    path: '/admin/link/edit',
    name: 'AdminLinkEdit',
    component: () => import('@/views/admin/link/edit')
  }
]

export default adminLinkRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/link.js